import { EditEntry, Entry } from "../entriesAPI";
import EntryLinks from "./EntryLinks";
import { Typography } from "@mui/material";

type Props = {
  entry: EditEntry | Entry;
  talentName: string;
  talentId: string;
};

const EntryTopInfo = ({ entry, talentName, talentId }: Props) => {
  const isLeave = !!entry?.leaveId;
  return isLeave ? (
    <Typography variant="header" fontSize="23px" fontWeight="600">
      {talentName}
    </Typography>
  ) : (
    <EntryLinks entry={entry} talentName={talentName} talentId={talentId} />
  );
};

export default EntryTopInfo;
